import React from 'react';
import Highlighter from 'react-highlight-words';
import { Badge } from 'react-bootstrap';
import ListSearch from '../list/ListSearch';

const customerFields = [
  'Address',
  'City',
  'Company Name',
  'Customer Number',
  'First Name',
  'Last Name',
  'Name',
  'Phone',
  'State',
  'Type',
  'Zip',
  'fullName',
  'itemid',
];

const CustomerSearch = props => {
  const renderSuggestion = (suggestion, { query }) => {
    const result = {};

    const style = {
      fontSize: '12px',
    };

    customerFields.forEach(part => {
      result[part] = suggestion[part];
      if (result[part]) {
        result[part] = (
          <Highlighter
            autoEscape
            highlightClassName="hl"
            searchWords={query.replace(':', '').split(/\s/)}
            textToHighlight={`${suggestion[part]}`}
          />
        );
      }
    });

    if (result.itemid === undefined) {
      result.itemid = result['Customer Number'];
    }

    // EQS5 introduced first/last names, and Name was changed to Company Name but still just Name for other customer lists
    const hasFullName = suggestion['First Name'] && suggestion['Last Name'];
    const customerName = hasFullName === true ? `${suggestion['First Name']} ${suggestion['Last Name']}` : result['Company Name'];

    return (
      <div>
        <div>
          {suggestion.Type === 'Prospect' && (
            <Badge variant="success" className="float-right mt-1" title="Prospective Customer">
              P
            </Badge>
          )}
          <b>{customerName || suggestion.Name}</b> ({result.itemid})
        </div>
        {hasFullName && (
          <div style={style}>
            {result['First Name']} {result['Last Name']}
          </div>
        )}
        {result.Address && <div style={style}>{result.Address}</div>}
        {(result.City || result.State || result.Zip) && (
          <div style={style}>
            {result.City}, {result.State} {result.Zip}
          </div>
        )}
        {result.Phone && (
          <div style={style}>
            <i className="zmdi zmdi-phone" style={style} /> {result.Phone}
          </div>
        )}
      </div>
    );
  };

  return <ListSearch {...props} renderSuggestion={renderSuggestion} />;
};

export default CustomerSearch;
